module.exports = __webpack_public_path__ + "img/video-control.124f22b4.jpg";